// import needed stuff
import { api } from '@moxiltd/moxijs/src/api/api.ts';
import { ApiClientFactory } from '@moxiltd/moxijs/src/api/apiclientfactory.ts';
import Bulma from '@vizuaalog/bulmajs/src/core.js';
import { initNavbar } from './nav.js';
import { fetchTeamCategory } from './team.js';
import { i18n } from '@moxiltd/moxijs/src/i18n.ts';
import initAnchorScrolls from './anchor.js';
import Notification from '@vizuaalog/bulmajs/src/plugins/notification.js';
import Swipe from 'swipejs';
import { activateSlider } from './news.js';

// make moxi functions available from outside, e.g. templates
window.moxi = {
    api,
    ApiClientFactory,
    i18n,
    initNavbar,
    fetchTeamCategory,
    initAnchorScrolls,
    activateSlider
};

// bulma-js
Bulma.registerPlugin('notification', Notification);
window.Bulma = Bulma;
window.Swipe = Swipe;

window.moxi.initNavbar();
window.moxi.activateSlider();
